import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import { IButtonProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IButtonProps>>
): IComponentSchema<IButtonProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Button',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Button,
    'x-component-props': {
      text: 'Button',
    },
    'x-component-props-config': {},
  };
};
